/**
 * Custom hook for login form logic
 * Separates business logic from UI components
 */

import { useState } from 'react';
import { Form, message } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import { LoginCredentials, LoginFormErrors } from '../types/auth.types';

export const useLoginForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const [ssoLoading, setSsoLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<LoginFormErrors>({});
  const { login } = useAuth();

  const handleLogin = async (credentials: LoginCredentials): Promise<void> => {
    try {
      setLoading(true);
      setErrors({});
      
      await login(credentials.username, credentials.password);
      message.success('Login successful!');
    } catch (error: any) {
      const errorMessage = error?.message || 'Login failed';
      setErrors({ general: errorMessage });
      message.error(errorMessage);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const handleSSOLogin = (): void => {
    setSsoLoading(true);
    // Simulate SSO loading
    setTimeout(() => {
      setSsoLoading(false);
      message.info('SSO functionality coming soon!', 2);
    }, 1000);
  };

  const handleForgotPassword = (): void => {
    message.info('Password reset functionality coming soon!', 2);
  };

  const clearErrors = (): void => {
    setErrors({});
  };

  return {
    form,
    loading,
    ssoLoading,
    errors,
    handleLogin,
    handleSSOLogin,
    handleForgotPassword,
    clearErrors,
  };
};